import { Button, Form } from 'antd';
import { CodeInput } from '../../../../../shared/components/CodeInput';
import { DisplayedCodeNotice } from '../../../../../shared/components/DisplayedCodeNotice';

interface ContactCodeFormProps {
  /** The new email or mobile, as people write it. */
  destination: string;
  displayedCode: string | null;
  submitting: boolean;
  onVerify: (code: string) => void;
  onResend: () => void;
  onCancel: () => void;
}

/** The second step of a change: the code sent to the new email or mobile, which saves it. */
export function ContactCodeForm({ destination, displayedCode, submitting, onVerify, onResend, onCancel }: ContactCodeFormProps) {
  return (
    <>
      {displayedCode ? (
        <DisplayedCodeNotice className="mb-4" code={displayedCode} />
      ) : (
        <p className="mb-4 text-sm text-muted">
          We sent a 6-digit code to <span className="font-medium text-fg">{destination}</span>. It expires in 10 minutes.
        </p>
      )}
      <Form<{ code: string }> layout="vertical" requiredMark={false} onFinish={(values) => onVerify(values.code)} disabled={submitting}>
        <Form.Item name="code" label="Enter the 6-digit code" rules={[{ required: true, message: 'Enter the 6-digit code' }]}>
          <CodeInput autoFocus onComplete={onVerify} />
        </Form.Item>
        <div className="flex flex-wrap gap-2">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Verify and save
          </Button>
          <Button onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button type="link" onClick={onResend} disabled={submitting}>
            Send another code
          </Button>
        </div>
      </Form>
    </>
  );
}
